import { Component, OnInit } from '@angular/core';
import { AppCommonService } from '../app-common.service';
import { Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'amazon-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent implements OnInit {
  public userid: string;

  constructor(
    private commonService: AppCommonService,
	private router: Router,
	private snackBar : MatSnackBar
  ) { }

  ngOnInit() {
  }

  forgotPassword() {
	//this.router.navigate(['/login']);
	let forgotPassword = {
		userid : this.userid
	}
	this.commonService.login('forgotpassword', forgotPassword).subscribe(response => {
		if (response.success) {
		  this.snackBar.open('Change password link sent your mail', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
		  this.router.navigate(['/login']);
		  // this.userid = '';
		} else {
		  this.snackBar.open((response.error && response.error.message ? response.error.message : window['serverError']), 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
		}
	  }, (er) => {
		this.snackBar.open((er.error && er.error.message && (typeof er.error.message === 'string')) ? er.error.message : 'User ID doesn\'t exist', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
	  });
  }
}
